import React from 'react'
import { Box, Link } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'
import { PRIVACY_POLICY_LABEL, TERMS_OF_SERVICE_LABEL } from '../../consent/consentCopy'
import type { LegalLinks } from '../../consent/types'

export interface TermsNoticeProps {
  /** The sentence opening, e.g. "By creating an account" (see TERMS_NOTICE_ACTION). */
  action: string
  links: LegalLinks
  className?: string
  sx?: SxProps<Theme>
}

/**
 * "<action>, you agree to the Terms of Service and confirm you've read the Privacy Policy."
 *
 * The notice replaces a Terms tick box (PO decision, SC-360). Links open in a new tab so a
 * half-filled form is not lost by reading the policy.
 */
const TermsNotice: React.FC<TermsNoticeProps> = ({ action, links, className, sx }) => (
  <Box className={className} sx={sx} data-testid="terms-notice">
    {action}, you agree to the{' '}
    <Link href={links.termsUrl} target="_blank" rel="noopener noreferrer" underline="hover">
      {TERMS_OF_SERVICE_LABEL}
    </Link>{' '}
    and confirm you&apos;ve read the{' '}
    <Link href={links.privacyUrl} target="_blank" rel="noopener noreferrer" underline="hover">
      {PRIVACY_POLICY_LABEL}
    </Link>
    .
  </Box>
)

export default TermsNotice
